import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../components/navbar/Navbar";
import Sidebar from "../components/navbar/Sidebar";
import ModelViewer from "../components/mainPageComps/ModelViewer";
import SidebarPanel from "../components/navbar/SidebarPanel";
// import Markups from "../components/sidePanelComps/Markups";
import ScreenshotMarkup from "../components/sidePanelComps/ScreenshotMarkup";
import fileBrowser from "../../src/assets/images/fileBrowser.png";
import config from "../../src/assets/images/config.png";
import markups from "../../src/assets/images/markupIconBlack.png";
import sheets from "../../src/assets/images/sheets.png";
import submittals from "../../src/assets/images/submittals.png";
import reviews from "../../src/assets/images/reviews.png";
import ModelLauncher from "../components/sidePanelComps/ModelLauncher";
import FolderFilters from "../components/sidePanelComps/FolderFilters";
import Sheets from "../components/sidePanelComps/Sheets";
import Schedules from "../components/fullPageComps/schedules";
import InformationManagement from "../components/sidePanelComps/InformationManagement";
import Checklists from "../components/mainPageComps/checklists";
import Submittals from "../components/fullPageComps/Submittals";
import {
  SELECTED_ICON,
  SELECTED_TREE_ITEMS,
  updateNavigationState,
} from "../helpers/reducers/NavigationReducer";
import {
  LAUNCH_VIEWER,
  MODEL_FILTER_STATE,
  SELECTED_DRAWING_SET,
  SELECTED_MODELS,
  SELECTED_OBJECT_DATA,
  SELECTED_SHEET,
  SHEETS_SELECTED,
  updateModelState,
} from "../helpers/reducers/ModelReducer";
import ProjectSetupNew from "../components/fullPageComps/ProjectSetupNew";

import ProjectConfig from "../components/fullPageComps/ProjectConfig";
import ObjectInterface from "../components/sidePanelComps/ObjectInterface";
import Maintenance from "../components/maintenance/Maintenance";
import Reviews from "../components/fullPageComps/Reviews";
import {
  ACC_SHEETS,
  SHOW_TOAST,
  TOAST_BODY,
  TOAST_TITLE,
  updateGlobalState,
} from "../helpers/reducers/GlobalReducer";
import LegacyModelSelector from "../components/sidePanelComps/LegacyModelSelector";
import LoadingScreen from "../components/loadingScreen/LoadingScreen";
import MarkupsInfo from "../components/fullPageComps/MarkupsInfo";
import Views from "../components/sidePanelComps/Views";

const Projects = () => {
  const { selectedIcon } = useSelector((state) => state.navigationReducer);
  const { selectedProject, userDetails, projectChangeLoading, allDocs, cloudFiles } =
    useSelector((state) => state.globalReducer);
  const [viewerState, setViewerState] = useState(null);
  const [markupExtension, setMarkupExtension] = useState(null);
  const [modelNodes, setModelNodes] = useState(null);
  const [isSidePanelCollapsed, setIsSidePanelCollapsed] = useState(false);
  const [isMarkupModeActive, setIsMarkupModeActive] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedIcon !== "Markup") {
      setIsMarkupModeActive(false);
    }
  }, [selectedIcon]);

  useEffect(() => {
    const projectInfo = selectedProject?.[0]?.mviewProjectInfo;
    const isLegacyProject =
      selectedProject?.[0]?.projectCode === "legacy" ||
      projectInfo?.projectCode === "legacy";
    const hasConfiguredProject = Boolean(projectInfo?.projectSetup);
    const hasCloudModels = Array.isArray(cloudFiles) && cloudFiles.length > 0;
    const hasProjectAssetTasks = Array.isArray(allDocs) && allDocs.length > 0;

    const shouldOpenProjectConfig =
      !projectChangeLoading &&
      selectedIcon === "File Browser" &&
      !isLegacyProject &&
      hasConfiguredProject &&
      !hasCloudModels &&
      !hasProjectAssetTasks;

    if (!shouldOpenProjectConfig) {
      return;
    }

    dispatch(
      updateNavigationState({
        value: "Project Config",
        stateName: SELECTED_ICON,
      }),
    );
    dispatch(
      updateGlobalState({
        value: "Project setup required",
        stateName: TOAST_TITLE,
      }),
    );
    dispatch(
      updateGlobalState({
        value:
          "No models were found for this project, please get a project admin to configure the project.",
        stateName: TOAST_BODY,
      }),
    );
    dispatch(
      updateGlobalState({
        value: true,
        stateName: SHOW_TOAST,
      }),
    );
    dispatch(
      updateModelState({
        value: false,
        stateName: LAUNCH_VIEWER,
      }),
    );
    dispatch(
      updateGlobalState({
        value: [],
        stateName: ACC_SHEETS,
      }),
    );
  }, [
    allDocs,
    cloudFiles,
    dispatch,
    projectChangeLoading,
    selectedIcon,
    selectedProject,
  ]);

  const buttonController = async (type) => {
    dispatch(
      updateNavigationState({
        value: type,
        stateName: SELECTED_ICON,
      }),
    );
    dispatch(
      updateModelState({
        value: null,
        stateName: SELECTED_DRAWING_SET,
      }),
    );

    if (
      type === "Sheets"
      // type === "Schedules" ||
      // type === "Project Config" ||
      // type === "ProjectSetup" ||
      // type === "Submittals" ||
      // type === "Reviews" ||
      // type === "Checklists" ||
      // type === "Maintenance"
    ) {
      dispatch(
        updateModelState({
          value: null,
          stateName: SELECTED_OBJECT_DATA,
        }),
      );
      dispatch(
        updateModelState({
          value: [],
          stateName: SELECTED_MODELS,
        }),
      );
      dispatch(
        updateModelState({
          value: false,
          stateName: SHEETS_SELECTED,
        }),
      );
      dispatch(
        updateModelState({
          value: null,
          stateName: SELECTED_SHEET,
        }),
      );
      dispatch(
        updateModelState({
          value: false,
          stateName: LAUNCH_VIEWER,
        }),
      );
      dispatch(
        updateNavigationState({
          value: [],
          stateName: SELECTED_TREE_ITEMS,
        }),
      );
      dispatch(
        updateModelState({
          value: { process: null, status: null, discipline: null },
          stateName: MODEL_FILTER_STATE,
        }),
      );
    }
    if (
      type === "Schedules" ||
      type === "Project Config" ||
      type === "ProjectSetup" ||
      type === "Submittals" ||
      type === "Reviews" ||
      type === "Checklists" ||
      type === "Maintenance" ||
      type === "Markups Information"
    ) {
      dispatch(
        updateModelState({
          value: false,
          stateName: LAUNCH_VIEWER,
        }),
      );
      dispatch(
        updateGlobalState({
          value: [],
          stateName: ACC_SHEETS,
        }),
      );
    }
    if (type === "File Browser") {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: ACC_SHEETS,
        }),
      );
      dispatch(
        updateModelState({
          value: false,
          stateName: SHEETS_SELECTED,
        }),
      );
    }
  };

  const updateModelNodes = (nodes) => {
    setModelNodes(nodes);
  };

  const triggerViewerResize = useCallback(() => {
    const viewer = viewerState?.viewer;

    if (!viewer) {
      return;
    }

    if (typeof viewer.resize === "function") {
      viewer.resize();
    }

    if (viewer.impl && typeof viewer.impl.resize === "function") {
      viewer.impl.resize();
    }

    if (viewer.impl && typeof viewer.impl.invalidate === "function") {
      viewer.impl.invalidate(true, true, true);
    }
  }, [viewerState]);

  const toggleSidePanel = useCallback(() => {
    setIsSidePanelCollapsed((prev) => !prev);

    // Let responsive components (for example AG Grid) recalculate after width transition.
    if (typeof window !== "undefined") {
      window.requestAnimationFrame(() => {
        triggerViewerResize();
        window.dispatchEvent(new Event("resize"));

        window.setTimeout(() => {
          triggerViewerResize();
          window.dispatchEvent(new Event("resize"));
        }, 260);

        window.requestAnimationFrame(() => {
          triggerViewerResize();
          window.dispatchEvent(new Event("resize"));
        });
      });
    }
  }, [triggerViewerResize]);

  // Memoize SidePanel to prevent unnecessary re-renders
  const MemoizedSidePanel = useMemo(() => {
    if (
      projectChangeLoading &&
      [
        "File Browser",
        "Properties",
        "Views",
        "Markup",
        "Sheets",
        "Legacy Browser",
      ].includes(selectedIcon)
    ) {
      return (
        <SidebarPanel>
          <LoadingScreen
            input="Loading Project"
            width="15"
            height="100%"
            marginTop="0"
            transparent={true}
          />
        </SidebarPanel>
      );
    }

    if (selectedIcon === "File Browser") {
      return (
        <>
          <SidebarPanel>
            <FolderFilters />
            <ModelLauncher />
            <InformationManagement
              viewerState={viewerState}
              modelNodes={modelNodes}
            />
            {/* <NewTreeView /> */}
          </SidebarPanel>
        </>
      );
    }
    if (
      selectedIcon === "Project Config" ||
      selectedIcon === "ProjectSetup" ||
      selectedIcon === "Submittals" ||
      selectedIcon === "Reviews" ||
      selectedIcon === "Markups Information"
    ) {
      return <></>;
    }
    // if (selectedIcon === "Submittals") {
    //   return <></>;
    // }
    if (selectedIcon === "Properties") {
      return (
        <SidebarPanel>
          {/* <Properties /> */}
          <ObjectInterface />
        </SidebarPanel>
      );
    }
    if (selectedIcon === "Views") {
      return (
        <SidebarPanel>
          <Views
            viewerState={viewerState}
            isPanelCollapsed={isSidePanelCollapsed}
          />
        </SidebarPanel>
      );
    }
    if (selectedIcon === "Markup") {
      return (
        <SidebarPanel>
          {/* <Markups
            viewerState={viewerState}
            markupExtension={markupExtension}
          /> */}
          <ScreenshotMarkup
            viewerState={viewerState}
            markupExtension={markupExtension}
            isPanelCollapsed={isSidePanelCollapsed}
            onMarkupModeChange={setIsMarkupModeActive}
          />
        </SidebarPanel>
      );
    }
    if (selectedIcon === "Sheets") {
      return (
        <SidebarPanel>
          <ModelLauncher />
          <Sheets viewerState={viewerState} />
        </SidebarPanel>
      );
    }
    if (selectedIcon === "Legacy Browser") {
      return (
        <SidebarPanel>
          <LegacyModelSelector />
          {/* need to create a legacy folder navigation component that just gives a drop down of all available models in ACC to  open up indivudually. */}
          <ModelLauncher />
        </SidebarPanel>
      );
    }
    return null;
  }, [
    selectedIcon,
    viewerState,
    modelNodes,
    markupExtension,
    projectChangeLoading,
    isSidePanelCollapsed,
  ]);

  const updateViewerState = (state) => {
    setViewerState(state);
  };

  const updateMarkupExtension = (state) => {
    setMarkupExtension(state);
  };

  const isFullPageContentView = [
    "Project Config",
    "ProjectSetup",
    "Submittals",
    "Reviews",
    "Schedules",
    "Checklists",
    "Maintenance",
  ].includes(selectedIcon);

  const canShowSidePanel = [
    "File Browser",
    "Properties",
    "Views",
    "Markup",
    "Sheets",
    "Legacy Browser",
  ].includes(selectedIcon);

  const keepSidePanelMountedWhileCollapsed =
    isSidePanelCollapsed && ["Markup", "Views"].includes(selectedIcon);

  const isSidePanelToggleDisabled =
    selectedIcon === "Markup" && isMarkupModeActive;

  const compactLeftOffset = "52px";

  const mainContentPaddingLeft = isFullPageContentView
    ? compactLeftOffset
    : canShowSidePanel && !isSidePanelCollapsed
      ? "0px"
      : compactLeftOffset;

  return (
    <div className="projects-page">
      <Navbar />
      {selectedProject[0]?.projectCode === "legacy" ? (
        <Sidebar>
          <>
            {selectedProject && (
              <>
                <li className="nav-item" style={{ marginTop: "5px" }}>
                  <button
                    type="button"
                    className="nav-link"
                    title="Model Browser"
                    data-bs-toggle="tooltip"
                    onClick={() => {
                      buttonController("Legacy Browser");
                    }}
                  >
                    <img
                      className="sideBarIcon"
                      src={fileBrowser}
                      alt="fileBrowser"
                    />
                  </button>
                </li>
              </>
            )}
          </>
        </Sidebar>
      ) : (
        <Sidebar>
          <>
            {selectedProject[0]?.mviewProjectInfo?.projectSetup ? (
              <>
                {selectedProject && (
                  <>
                    <li className="sidebar-section-label" aria-hidden="true">
                      Design
                    </li>
                    <li className="nav-item" style={{ marginTop: "5px" }}>
                      <button
                        type="button"
                        className="nav-link"
                        title="Model Browser"
                        data-bs-toggle="tooltip"
                        onClick={() => {
                          buttonController("File Browser");
                        }}
                      >
                        <img
                          className="sideBarIcon"
                          src={fileBrowser}
                          alt="fileBrowser"
                        />
                      </button>
                    </li>
                    {/* <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link nav-btn"
                      title="Markups"
                      data-bs-toggle="tooltip"
                      onClick={() => {
                        buttonController("Markup");
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                      }}
                    >
                      <img
                        className="sideBarIcon"
                        src={markupIcon}
                        alt="markups"
                      />
                    </button>
                  </li> */}
                    <li className="nav-item">
                      <button
                        type="button"
                        className="nav-link"
                        title="Drawing Sets"
                        data-bs-toggle="tooltip"
                        onClick={() => {
                          buttonController("Sheets");
                        }}
                      >
                        <img
                          className="sideBarIcon"
                          src={sheets}
                          alt="sheets"
                        />
                      </button>
                    </li>
                    {/* <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link nav-btn"
                      title="Object Properties"
                      data-bs-toggle="tooltip"
                      onClick={() => {
                        buttonController("Properties");
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                      }}
                    >
                      <img
                        className="sideBarIcon"
                        src={properties}
                        alt="properties"
                      />
                    </button>
                  </li> */}

                    {/* <br />

                  <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link nav-btn"
                      title="Schedules"
                      data-bs-toggle="tooltip"
                      onClick={() => {
                        buttonController("Schedules");
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                      }}
                    >
                      <img
                        className="sideBarIcon"
                        src={schedules}
                        alt="schedules"
                      />
                    </button>
                  </li> */}
                    {/* <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link nav-btn"
                      title="Checklists"
                      data-bs-toggle="tooltip"
                      onClick={() => {
                        buttonController("Checklists");
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                      }}
                    >
                      <img
                        className="sideBarIcon"
                        src={checklists}
                        alt="checklists"
                      />
                    </button>
                  </li> */}
                    {/* <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link nav-btn"
                      title="Maintenance"
                      data-bs-toggle="tooltip"
                      onClick={() => {
                        buttonController("Maintenance");
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                      }}
                    >
                      <img
                        className="sideBarIcon"
                        src={maintenance}
                        alt="Maintenance"
                      />
                    </button>
                  </li> */}
                    {/* <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      title="Test"
                      data-bs-toggle="tooltip"
                      onClick={(e) => {
                        buttonController("Test");
                      }}
                    >
                      <h1>T</h1>
                    </a>
                  </li> */}
                    <li
                      className="sidebar-section-divider"
                      aria-hidden="true"
                    />
                    <li className="sidebar-section-label" aria-hidden="true">
                      Project Info
                    </li>
                    <li className="nav-item">
                      <button
                        type="button"
                        className="nav-link"
                        title="Project Configuration"
                        data-bs-toggle="tooltip"
                        onClick={() => {
                          buttonController("Project Config");
                        }}
                      >
                        <img
                          className="sideBarIcon"
                          src={config}
                          alt="projectConfig"
                        />
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        type="button"
                        className="nav-link"
                        title="Markup Information"
                        data-bs-toggle="tooltip"
                        onClick={() => {
                          buttonController("Markups Information");
                        }}
                      >
                        <img
                          className="sideBarIcon"
                          src={markups}
                          alt="Markup Information"
                        />
                      </button>
                    </li>
                  
                        <li className="nav-item">
                          <button
                            type="button"
                            className="nav-link"
                            title="Submittals"
                            data-bs-toggle="tooltip"
                            onClick={() => {
                              buttonController("Submittals");
                            }}
                          >
                            <img
                              className="sideBarIcon"
                              src={submittals}
                              alt="Submittals"
                            />
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            type="button"
                            className="nav-link"
                            title="Reviews"
                            data-bs-toggle="tooltip"
                            onClick={() => {
                              buttonController("Reviews");
                            }}
                          >
                            <img
                              className="sideBarIcon"
                              src={reviews}
                              alt="Reviews"
                            />
                          </button>
                        </li>
                      </>
                    )}
                
              </>
            ) : (
              <>
                {userDetails?.role === "Design Manager" && (
                  <li className="nav-item" style={{ marginTop: "5px" }} >
                    <button
                      type="button"
                      className="nav-link"
                      title="Project Setup"
                      data-bs-toggle="tooltip"
                      onClick={() => {
                        buttonController("ProjectSetup");
                      }}
                    >
                      <img
                        className="sideBarIcon"
                        src={config}
                        alt="projectsetup"
                      />
                    </button>
                  </li>
                )}
              </>
            )}
          </>
        </Sidebar>
      )}
      <div className="container-fluid projects-layout">
        <div className="row projects-row">
          {canShowSidePanel && (
            <div
              className={`col-3 projects-sidepanel-shell ${
                isSidePanelCollapsed ? "is-collapsed" : ""
              }`}
            >
              {(!isSidePanelCollapsed || keepSidePanelMountedWhileCollapsed) &&
                MemoizedSidePanel}
              <button
                type="button"
                className="sidebar-panel__toggle"
                onClick={toggleSidePanel}
                disabled={isSidePanelToggleDisabled}
                aria-label={
                  isSidePanelToggleDisabled
                    ? "Side panel toggle disabled while markup mode is active"
                    : isSidePanelCollapsed
                    ? "Expand side panel"
                    : "Collapse side panel"
                }
                title={
                  isSidePanelToggleDisabled
                    ? "Exit markup mode to expand or collapse the panel"
                    : isSidePanelCollapsed
                      ? "Expand panel"
                      : "Collapse panel"
                }
              >
                <span aria-hidden="true">{isSidePanelCollapsed ? ">" : "<"}</span>
              </button>
            </div>
          )}
          {/* <SidePanel /> */}
          {/* <MainPage /> */}

          <div
            className="col projects-content-col"
            style={{
              paddingLeft: mainContentPaddingLeft,
              paddingRight: "5px",
            }}
          >
            <div
              className="projects-content-shell"
              style={{
                position: "relative",
                margin: "2px",
                // height: "100%",

                height: "calc(100% - 4px)",

                width: "100%",
              }}
            >
              {projectChangeLoading ? (
                <LoadingScreen
                  input="Loading Project"
                  width="12"
                  height="100%"
                  marginTop="6%"
                  variant="properties"
                  subtitle="Loading project details..."
                  transparent={true}
                />
              ) : (
                <>
                  {[
                    "File Browser",
                    "Properties",
                    "Markup",
                    "Workflows",
                    "Sheets",
                      "Legacy Browser",
                    "Views",
                  ].includes(selectedIcon) && (
                    <ModelViewer
                      updateViewerState={updateViewerState}
                      updateModelNodes={updateModelNodes}
                      updateMarkupExtension={updateMarkupExtension}
                    />
                  )}

                  {selectedIcon === "Project Config" && <ProjectConfig />}
                  {selectedIcon === "Markups Information" && <MarkupsInfo />}

                  {selectedIcon === "ProjectSetup" && <ProjectSetupNew />}
                  {selectedIcon === "Submittals" && <Submittals />}
                  {selectedIcon === "Reviews" && <Reviews />}

                  {selectedIcon === "Schedules" && <Schedules />}

                  {selectedIcon === "Checklists" && <Checklists />}
                  {selectedIcon === "Maintenance" && <Maintenance />}
                </>
              )}
              {/* {selectedIcon === "Test" && (
                <div className="container-fluid ps-4">
                  <TestReusableViewer />
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
